/**
 * ============================================================
 * DIBAI 18K — Lista de Deseos
 * assets/wishlist-dibai.js  v1.1.0
 * ============================================================
 */

(function () {
  'use strict';

  const STORAGE_KEY = 'dibai_wishlist';

  // ─────────────────────────────────────────
  // STORAGE
  // ─────────────────────────────────────────
  const Storage = {
    get()  {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
      catch { return []; }
    },
    set(items)     { try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); } catch {} },
    add(id)        { const l = this.get(); if (!l.includes(id)) { l.push(id); this.set(l); } },
    remove(id)     { this.set(this.get().filter(i => i !== id)); },
    has(id)        { return this.get().includes(id); },
    clear()        { this.set([]); },
    count()        { return this.get().length; },
  };

  // ─────────────────────────────────────────
  // BADGE DEL HEADER
  // ─────────────────────────────────────────
  function updateHeaderBadge() {
    const count = Storage.count();
    document.querySelectorAll('[data-wishlist-count]').forEach(el => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  // ─────────────────────────────────────────
  // BOTONES ❤️
  // ─────────────────────────────────────────
  function updateButton(btn, inWishlist) {
    btn.classList.toggle('is-wishlisted', inWishlist);
    btn.setAttribute('aria-label',
      inWishlist ? 'Quitar de lista de deseos' : 'Agregar a lista de deseos'
    );
    // Rellenar el corazón si está en wishlist
    const path = btn.querySelector('svg path');
    if (path) {
      path.setAttribute('fill', inWishlist ? '#c9a84c' : 'none');
      path.setAttribute('stroke', inWishlist ? '#c9a84c' : 'currentColor');
    }
  }

  function updateWishlistButtons(productId, inWishlist) {
    const id = String(productId);
    document.querySelectorAll(
      `[data-wishlist-product-id="${id}"],
       [data-product-id="${id}"][data-wishlist-add],
       [data-wk-product="${id}"]`
    ).forEach(btn => updateButton(btn, inWishlist));
  }

  function updateAllButtons() {
    const ids = Storage.get().map(String);
    document.querySelectorAll(
      '[data-wishlist-product-id],[data-wishlist-add],[data-wk-product]'
    ).forEach(btn => {
      const id =
        btn.dataset.wishlistProductId ||
        btn.dataset.wishlistAdd ||
        btn.dataset.wkProduct ||
        btn.dataset.productId;
      if (id && id !== 'true') updateButton(btn, ids.includes(String(id)));
    });
  }

  // ─────────────────────────────────────────
  // TOGGLE
  // ─────────────────────────────────────────
  function toggleWishlist(productId) {
    const id = String(parseInt(productId, 10));
    if (!id || id === 'NaN') return;

    const inWishlist = Storage.has(id);
    if (inWishlist) {
      Storage.remove(id);
    } else {
      Storage.add(id);
    }

    updateWishlistButtons(id, !inWishlist);
    updateHeaderBadge();
    showToast(!inWishlist
      ? '❤️ Agregado a tu lista de deseos'
      : 'Quitado de la lista de deseos'
    );
  }

  // ─────────────────────────────────────────
  // TOAST
  // ─────────────────────────────────────────
  let _toastTimer;
  function showToast(msg) {
    let t = document.getElementById('wl-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'wl-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      t.style.cssText = `
        position:fixed;bottom:28px;left:50%;
        transform:translateX(-50%) translateY(80px);
        background:#111;color:#fff;padding:12px 24px;
        font-family:'Montserrat',sans-serif;font-size:13px;font-weight:500;
        border-radius:0;z-index:9999;white-space:nowrap;
        box-shadow:0 8px 24px rgba(0,0,0,0.2);
        transition:transform .3s ease,opacity .3s ease;
        opacity:0;pointer-events:none;
      `;
      document.body.appendChild(t);
    }
    t.textContent = msg;
    requestAnimationFrame(() => {
      t.style.transform = 'translateX(-50%) translateY(0)';
      t.style.opacity   = '1';
    });
    clearTimeout(_toastTimer);
    _toastTimer = setTimeout(() => {
      t.style.transform = 'translateX(-50%) translateY(80px)';
      t.style.opacity   = '0';
    }, 2800);
  }

  // ─────────────────────────────────────────
  // CLICK HANDLER
  // ─────────────────────────────────────────
  function bindWishlistButtons() {
    document.addEventListener('click', e => {
      const btn = e.target.closest(
        '[data-wishlist-product-id],[data-wishlist-add],[data-wk-product]'
      );
      if (!btn) return;
      const id =
        btn.dataset.wishlistProductId ||
        btn.dataset.wishlistAdd ||
        btn.dataset.wkProduct ||
        btn.dataset.productId;
      if (!id || id === 'true') return;
      e.preventDefault();
      e.stopPropagation();
      toggleWishlist(id);
    });
  }

  // ─────────────────────────────────────────
  // WISHLIST PAGE — carga productos por handle
  // via Shopify Search AJAX API
  // ─────────────────────────────────────────
  async function loadWishlistPage() {
    const wrapper = document.querySelector('.wishlist-dibai-wrapper');
    if (!wrapper) return;

    const grid     = wrapper.querySelector('[data-wl-grid]');
    const emptyEl  = wrapper.querySelector('[data-wl-empty]');
    const actionsEl= wrapper.querySelector('[data-wl-actions]');
    const loaderEl = wrapper.querySelector('[data-wl-loader]');
    const countEl  = wrapper.querySelector('[data-wl-count]');
    const tmpl     = document.getElementById('wl-card-template');

    if (!grid || !tmpl) return;

    loaderEl?.removeAttribute('hidden');

    const ids = Storage.get().map(String);

    if (ids.length === 0) {
      loaderEl?.setAttribute('hidden', '');
      emptyEl?.removeAttribute('hidden');
      actionsEl?.setAttribute('hidden', '');
      if (countEl) countEl.textContent = '';
      return;
    }

    // ── Cargar productos usando /search/suggest.json filtrado por IDs ──
    // La API de búsqueda de Shopify acepta query por ID numérico
    // Estrategia: usar /products.json con el parámetro ids (disponible en Shopify)
    let products = [];

    try {
      // Endpoint estándar de Shopify AJAX: soporta filtrado por IDs
      const url = `/products.json?limit=250`;
      const res = await fetch(url, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (res.ok) {
        const data = await res.json();
        // Filtrar los que están en wishlist
        products = (data.products || []).filter(p =>
          ids.includes(String(p.id))
        );
      }
    } catch (err) {
      console.warn('[WishlistDibai] /products.json error:', err);
    }

    // Si no encontramos todos, buscar los que faltan uno a uno via search
    const foundIds   = products.map(p => String(p.id));
    const missingIds = ids.filter(id => !foundIds.includes(id));

    if (missingIds.length > 0) {
      const searches = missingIds.map(id =>
        fetch(`/search/suggest.json?q=${id}&resources[type]=product&resources[limit]=1`)
          .then(r => r.ok ? r.json() : null)
          .then(data => {
            const items = data?.resources?.results?.products || [];
            // Verificar que el ID coincide exactamente
            return items.find(p => String(p.id) === id) || null;
          })
          .catch(() => null)
      );

      const results = await Promise.all(searches);
      results.forEach(p => {
        if (p) {
          // Normalizar estructura (search API usa campos diferentes)
          products.push({
            id:             p.id,
            title:          p.title,
            handle:         p.handle,
            images:         p.image ? [{ src: p.image }] : [],
            featured_image: p.image,
            variants:       p.variants || [{ price: p.price, available: true }],
          });
        }
      });
    }

    loaderEl?.setAttribute('hidden', '');

    if (products.length === 0) {
      emptyEl?.removeAttribute('hidden');
      actionsEl?.setAttribute('hidden', '');
      if (countEl) countEl.textContent = '';
      return;
    }

    emptyEl?.setAttribute('hidden', '');
    actionsEl?.removeAttribute('hidden');

    // Ordenar: más reciente primero (orden en localStorage, invertido)
    const ordered = [...ids]
      .reverse()
      .map(id => products.find(p => String(p.id) === id))
      .filter(Boolean);

    if (countEl) {
      const n = ordered.length;
      countEl.textContent = `${n} ${n === 1 ? 'producto' : 'productos'}`;
    }

    // Limpiar grid antes de renderizar (evita duplicados si se llama dos veces)
    grid.innerHTML = '';

    ordered.forEach(product => {
      const frag = renderCard(tmpl, product);
      if (frag) grid.appendChild(frag);
    });

    bindCardActions(grid, wrapper, countEl, emptyEl, actionsEl);
    bindGlobalActions(wrapper, ordered, emptyEl, actionsEl, countEl, grid);
  }

  // ─────────────────────────────────────────
  // RENDER CARD
  // ─────────────────────────────────────────
  function renderCard(tmpl, product) {
    const frag = tmpl.content.cloneNode(true);
    const card = frag.querySelector('.wl-card');
    if (!card) return null;

    card.dataset.productId = String(product.id);

    const url = `/products/${product.handle}`;

    // Imagen
    const img    = card.querySelector('[data-wl-img]');
    const rawSrc = product.featured_image || product.images?.[0]?.src || '';
    if (img && rawSrc) {
      // Shopify CDN: agregar _400x400 para tamaño optimizado
      const src = rawSrc.includes('cdn.shopify.com')
        ? rawSrc.replace(/(\.[a-z]+)(\?|$)/, '_400x400$1$2')
        : rawSrc;
      img.src = src;
      img.alt = product.title;
    }

    // Links
    card.querySelectorAll('[data-wl-product-link]').forEach(el => {
      el.href = url;
    });

    // Título
    const titleLink = card.querySelector('.wl-card__title-link');
    if (titleLink) titleLink.textContent = product.title;

    // Precio
    const priceEl = card.querySelector('[data-wl-price]');
    if (priceEl) {
      const variant      = product.variants?.[0];
      const price        = variant?.price;
      const comparePrice = variant?.compare_at_price;

      if (price !== undefined) {
        const fmtPrice   = formatMoney(price);
        const fmtCompare = comparePrice && comparePrice > price
          ? formatMoney(comparePrice) : null;
        priceEl.innerHTML = fmtCompare
          ? `<span class="wl-card__price-compare">${fmtCompare}</span>${fmtPrice}`
          : fmtPrice;
      }
    }

    // Botón remove
    const removeBtn = card.querySelector('[data-wl-remove]');
    if (removeBtn) removeBtn.dataset.productId = String(product.id);

    // Botón ATC — agregar variante ID y hacer funcional
    const atcBtn = card.querySelector('[data-wl-atc]');
    if (atcBtn) {
      const variant = product.variants?.[0];
      if (variant && variant.available !== false) {
        atcBtn.dataset.variantId = String(variant.id);
        atcBtn.dataset.productId = String(product.id);
        atcBtn.removeAttribute('hidden');
      } else {
        atcBtn.textContent = 'Agotado';
        atcBtn.disabled = true;
      }
    }

    return frag;
  }

  // ─────────────────────────────────────────
  // CARD ACTIONS
  // ─────────────────────────────────────────
  function bindCardActions(grid, wrapper, countEl, emptyEl, actionsEl) {
    grid.addEventListener('click', async e => {
      // ── ATC ──
      const atcBtn = e.target.closest('[data-wl-atc]');
      if (atcBtn && !atcBtn.disabled) {
        const variantId = atcBtn.dataset.variantId;
        if (!variantId) return;
        const origText = atcBtn.textContent;
        atcBtn.disabled = true;
        atcBtn.textContent = '...';
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
          });
          if (res.ok) {
            atcBtn.textContent = '✓ Agregado';
            showToast('Producto agregado al carrito');
            // Actualizar bubble del carrito
            const cartRes = await fetch('/cart.js');
            if (cartRes.ok) {
              const cartData = await cartRes.json();
              document.querySelectorAll('.cart-bubble__text-count,[data-cart-count]').forEach(el => {
                el.textContent = cartData.item_count;
              });
            }
            // Refrescar el contenido del cart drawer y luego abrirlo
            await refreshCartDrawer();
            setTimeout(() => { atcBtn.textContent = origText; atcBtn.disabled = false; }, 2000);
          } else {
            const err = await res.json();
            console.error('[WL ATC]', err);
            atcBtn.textContent = origText;
            atcBtn.disabled = false;
          }
        } catch(err) {
          console.error('[WL ATC]', err);
          atcBtn.textContent = origText;
          atcBtn.disabled = false;
        }
        return;
      }

      // ── REMOVE ──
      const removeBtn = e.target.closest('[data-wl-remove]');
      if (!removeBtn) return;

      const card = removeBtn.closest('.wl-card');
      const id   = card?.dataset.productId;
      if (!id) return;

      // Animación salida
      card.style.cssText += 'opacity:0;transform:scale(0.9);transition:opacity .25s,transform .25s;';
      setTimeout(() => {
        card.remove();
        Storage.remove(id);
        updateWishlistButtons(id, false);
        updateHeaderBadge();

        const remaining = grid.querySelectorAll('.wl-card').length;
        if (remaining === 0) {
          emptyEl?.removeAttribute('hidden');
          actionsEl?.setAttribute('hidden', '');
          if (countEl) countEl.textContent = '';
        } else if (countEl) {
          countEl.textContent = `${remaining} ${remaining === 1 ? 'producto' : 'productos'}`;
        }
        showToast('Quitado de la lista de deseos');
      }, 260);
    });
  }

  function bindGlobalActions(wrapper, products, emptyEl, actionsEl, countEl, grid) {
    const clearBtn  = wrapper.querySelector('[data-wl-clear]');
    const addAllBtn = wrapper.querySelector('[data-wl-add-all]');

    clearBtn?.addEventListener('click', () => {
      if (!confirm('¿Estás seguro de que quieres vaciar tu lista de deseos?')) return;
      Storage.clear();
      updateHeaderBadge();
      grid.innerHTML = '';
      emptyEl?.removeAttribute('hidden');
      actionsEl?.setAttribute('hidden', '');
      if (countEl) countEl.textContent = '';
    });

    addAllBtn?.addEventListener('click', async () => {
      addAllBtn.disabled    = true;
      addAllBtn.textContent = 'Agregando...';
      let added = 0;

      for (const product of products) {
        const variant = product.variants?.[0];
        if (variant?.available !== false) {
          try {
            await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify({ id: variant?.id || product.id, quantity: 1 }),
            });
            added++;
          } catch {}
        }
      }

      addAllBtn.disabled    = false;
      addAllBtn.textContent = 'Agregar todo al carrito';
      showToast(`${added} ${added === 1 ? 'producto agregado' : 'productos agregados'} al carrito`);

      // Refrescar y abrir cart drawer
      await refreshCartDrawer();
    });
  }

  // ─────────────────────────────────────────
  // FORMATO PRECIO
  // ─────────────────────────────────────────
  function formatMoney(price) {
    // /products.json devuelve el precio en pesos colombianos directamente
    // (ej: 1448800 = $1.448.800) — NO dividir por 100
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(price);
  }

  // ─────────────────────────────────────────
  // OPEN CART DRAWER
  // Dispara el evento nativo de Shopify/Horizon que cart-drawer-component
  // escucha para refrescarse y abrirse automáticamente.
  // ─────────────────────────────────────────
  async function refreshCartDrawer() {
    // Fetch del contenido actualizado del carrito via Sections API
    // Esto devuelve el HTML completo del cart-drawer-section ya renderizado
    const sectionsPromise = fetch('/?sections=cart-drawer-section', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(r => r.ok ? r.json() : null)
    .then(data => {
      if (!data) return { detail: { didError: true } };

      const html = data['cart-drawer-section'];
      if (html) {
        // Usar morphdom-style update: reemplazar la sección completa
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        // Extraer solo el interior del cart-drawer-component
        const newCartInner = tempDiv.querySelector('cart-drawer-component');
        const curCartInner = document.querySelector('cart-drawer-component');
        if (newCartInner && curCartInner) {
          // Reemplazar nodo completo para que los WC se re-inicialicen
          curCartInner.replaceWith(newCartInner.cloneNode(true));
        }
      }

      return { detail: { didError: false } };
    })
    .catch(() => ({ detail: { didError: true } }));

    // Disparar el evento estándar de Shopify con action:'add' y la promise
    // El cart-drawer-component escucha 'shopify:cart:lines-update' y abre
    // el drawer cuando action === 'add' y la promise resuelve sin error
    const event = new CustomEvent('shopify:cart:lines-update', {
      bubbles: true,
      cancelable: false,
    });
    Object.defineProperties(event, {
      action:  { value: 'add',             writable: false },
      promise: { value: sectionsPromise,    writable: false },
    });
    document.dispatchEvent(event);

    // Esperar a que resuelva y abrir el drawer directamente también
    const result = await sectionsPromise;
    if (!result?.detail?.didError) {
      const cartDrawer = document.getElementById('cart-drawer');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }
    }
  }

  // ─────────────────────────────────────────
  // SINCRONIZACIÓN entre pestañas
  // ─────────────────────────────────────────
  window.addEventListener('storage', e => {
    if (e.key === STORAGE_KEY) {
      updateAllButtons();
      updateHeaderBadge();
    }
  });

  // ─────────────────────────────────────────
  // INIT
  // ─────────────────────────────────────────
  function init() {
    bindWishlistButtons();
    updateAllButtons();
    updateHeaderBadge();
    if (document.querySelector('.wishlist-dibai-wrapper')) {
      loadWishlistPage();
    }
  }

  // ── Observar cambios en el cart bubble nativo de Horizon ──
  // Cuando el cart drawer actualiza el conteo, Horizon actualiza
  // el elemento #cart-bubble-text. Escuchamos esos cambios para
  // mantener nuestro badge sincronizado.
  // ──────────────────────────────────────────────────────────────
  // Sincronizar el badge del carrito en TODAS las páginas.
  // Horizon actualiza el bubble via su WC interno — lo observamos
  // y forzamos un re-fetch del conteo real desde /cart.js
  // ──────────────────────────────────────────────────────────────
  function observeCartBubble() {
    // Escuchar el evento nativo de Shopify que se dispara al cambiar el carrito
    document.addEventListener('shopify:cart:lines-update', syncCartCount);

    // También pollear /cart.js cada vez que el drawer se abre/cierra
    // para sincronizar el badge
    const cartDrawer = document.getElementById('cart-drawer');
    if (cartDrawer) {
      // MutationObserver en el atributo 'open' del theme-drawer
      new MutationObserver(() => {
        // Cuando el drawer se cierra (se quita 'open'), refrescar el conteo
        if (!cartDrawer.hasAttribute('open')) {
          syncCartCount();
        }
      }).observe(cartDrawer, { attributes: true, attributeFilter: ['open'] });
    }

    // Sincronizar al cargar la página
    syncCartCount();
  }

  async function syncCartCount() {
    try {
      const res = await fetch('/cart.js', {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!res.ok) return;
      const cart = await res.json();
      const count = cart.item_count || 0;

      // Actualizar TODOS los bubbles del carrito en la página
      // Horizon usa .cart-bubble__text-count con id="cart-bubble-text"
      document.querySelectorAll(
        '#cart-bubble-text .cart-bubble__text-count, .cart-bubble__text-count'
      ).forEach(el => {
        el.textContent = count;
        // Mostrar/ocultar según si hay items
        el.classList.toggle('hidden', count === 0);
        // El padre .cart-bubble también tiene clase visually-hidden cuando está vacío
        const bubble = el.closest('.cart-bubble');
        if (bubble) bubble.classList.toggle('visually-hidden', count === 0);
      });
    } catch {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { init(); observeCartBubble(); });
  } else {
    init();
    observeCartBubble();
  }

  document.addEventListener('shopify:section:load', () => {
    updateAllButtons();
    updateHeaderBadge();
    if (document.querySelector('.wishlist-dibai-wrapper')) loadWishlistPage();
  });

  // API global
  window.DibaiWishlist = {
    toggle: toggleWishlist,
    has:    id => Storage.has(String(parseInt(id))),
    add:    id => { Storage.add(String(parseInt(id))); updateWishlistButtons(id, true); updateHeaderBadge(); },
    remove: id => { Storage.remove(String(parseInt(id))); updateWishlistButtons(id, false); updateHeaderBadge(); },
    getIds: () => Storage.get(),
    count:  () => Storage.count(),
  };

})();
